import login from "../i18n/en/Login"

export default {
  login,
  home: {
    'deviceState': 'State',
    'totalAuthorized': 'totality',
    'beAuthorized': 'Granted ',
    'onLine': 'on line',
    'offLine': 'off-line',
    'taskState': 'task state',
    'totalProgram': 'totality ',
    'approve': 'approve ',
    'reject': 'Audit failed',
    'unreviewed': 'unreviewed ',
    'verified': 'verified ',
    'refuse': 'refuse ',
    'MaterialStatistics': 'Material statistics',
    'img': 'img',
    'video': 'video',
    'frequency': 'frequency',
    'doc': 'doc',
    'systeminfo': 'system information',
    'totalMemory': 'total memory',
    'USED': 'USED',
    'residue': 'residue',
    'platform': 'platform',
    'individual': 'individual',
  },
  terminal: {
    'deviceState': 'deviceState',
    'deviceglTitle': 'management',
    'DeviceProperties': 'Properties',
    'device': {
      'MBFree': 'MB Free',
      'deviceState': 'State',
      'deviceName': 'Name ',
      'devicenumber': 'Device Identifier',
      'deviceRAM': 'Memory',
      'deviceID': 'ID',
      'deviceMAC': 'Mac',
      "a_key_phone": "One button alarm call",
      'screenNumber': 'number',
      'deviceLshoocation': 'Location',
      'AUTHORISE': 'Author',
      'beAuthorized': 'Authorized',
      'unauthorized': 'Unauthorized',
      'resolution': 'HVGA',
      'remarks': 'Notes',
      'deviceIP': 'IP',
      'sysversion': 'Version',
      'ViewTask': 'Check',
      'offlineTime': 'OfflineDuration',
      'onofftime': 'Launch and Shutdown Period',
      'uptime': 'PowerOn',
      'offTime': 'PowerOff',
      'Mon': 'Mon',
      'Tues': 'Tues',
      'Wednes': 'Wed',
      'Thurs': 'Thu',
      'Fri': 'Fri',
      'Satur': 'Sat',
      'sun': 'sun',
      'operation': 'Operation',
      'type': 'Type',
      'taskName': 'Name',
      'dutyCycle': 'TaskCycle',
      'startTime': 'StartPoint',
      'endTime': 'EndPoint',
      'dateline': 'SendTime',
      'ClearExpired': 'Clear expired',
      'starttime': 'start time',
      'endtime': 'end time',
      'sbjc': 'device testing',
      'sbjcz': 'Equipment testing',
      'successfully': 'successfully',
      'serverIp': 'serverIp',
    },
    'command': 'order',
    'control': 'monitor',
    'setting': 'setting',
    'upgradeTitle': 'update',
    'upgrade': {
      'fileType': 'file Type',
      'fileName': 'file Name',
      'versionNum': 'AppVersion',
      'versionName': 'package',
      'sysversion': 'sysVersion',
      'upTime': 'updateTime',
      'serialName': 'serial',
      'facilityID': 'ID',
      'deviceName': 'deviceName',
      'downSeed': 'speed',
      'downprogress': 'progress',
      'downState': 'status',
      'eliminate': 'clear',
      'inquire': 'query',
      'Upgrademanagement': 'Upgrade management',
      'UpgradeList': 'Upgrade List',
      'Upgradeequipment': 'Upgrade equipment',
      'speed': 'speed',
      'progress': 'progress',
      'remote': 'RMON',
      'Interface': 'Interface acquisition',
      'preview': 'Double click to preview the image',
      "interface": 'monitoring interface'
    },
    'StatisticsTitle': 'statistics',
    'Statistics': {
      'fileName': 'name',
      'preview': 'preview',
      'type': 'type',
      'number': 'number',
      'statistical': 'timeTotal',
      'operation': 'deal',
      'a': 'stand',
    },
    registrationTitle: 'register',
    registration: {
      'icon': 'icon',
      'facilityID': 'ID',
      'facilityIP': 'IP',

    },
    instruct: {
      volume: 'volume',
      restart: 'reboot',
      rouse: 'rouse',
      sleep: 'sleep',
      shutdown: 'shutdown',
      qlds: 'Cleaning time',
      qlcp: 'disk clean',
      qlrw: 'Cleaning Job',
      LoadingTitle: 'nstructions issued by',
      titlemini: 'Under command',
      adjust: 'adjust volume',
    },
    flow: {
      flow: 'flow',
      diagramName: "In flow diagram",
      chart: "The flow chart",
      Daily: "Daily flow chart",
      tip: "Please click on the bar chart for details"
    },
    deviceList: 'deviceList',
  },
  material: {
    name: 'Name',
    materialType: 'Type',
    state: 'State',
    fileSize: 'fileSize',
    scupload: 'Material to upload',
    zzscdsl: 'Number of uploads in progress',
    updata: 'uploading',
    abortUpdata: 'Stop uploading',
    upfairly: 'fail to upload',
    uploaded: 'uploaded',
    Boundmaterial: 'Bound material',
    Boundpo: 'Bundled programs',
    upch: 'upload successful',
    'material_group': 'material group'
  },
  program: {
    'Screeningstate': 'Screening state',
    'programType': 'Type',
    'hdjm': 'interactive programme',
    'ptjm': 'ordinary program',
    'unreviewed': 'unreviewed ',
    'verified': 'verified ',
    'refuse': 'refuse ',
    'unused': 'unused',
    'qsrjmmc': 'Please enter the program name',
    'program': 'program',
    'tasks': 'Number of tasks',
    'resolution': 'resolution',
    'xxcb': 'Message spot',
    'width': 'width',
    'height': 'height',
    'task': 'grouping',
    'qxzwj': 'Please select program categories',
    'create': 'create',
    'addResolution': 'addResolution',
    'programName': 'Name',
    'auditstatus': 'audit status',
    'onstate': 'on State',
    'guanlian': 'task Number',
    'pass': 'pass',
    'refusea': 'refuse',
    'cjjm': 'Create program',
    'scenesetting': 'scene setting',
    'sceneTime': 'Scene Time',
    'bgImg': 'backgroundImg',
    'top': 'Top',
    'left': 'Left',
    'jmcj': 'scene',
    'addbg': 'Add background image',
    'selesc': 'Number of selected materials',
    'adddecive': 'Add Device',
    'selecteddevice': 'selected device',
    'review': 'Program review',
    'xgfz': 'Change groups',
    'audit': 'audit',
    'template': 'template list',
    'move': 'move',
    'delcontrol': 'delete',
    'full': 'full',
    'addsucai': 'Add material',
    'sticky': 'sticky',
    'Bottom': 'Bottom',
    'ascend': 'ascend',
    'descend': 'descend',
    'DaemonTime': "Daemon time",
    "VideoDisplayType": "Video display type",
    "ImageDisplayType": "Image display type",
    'DualConfiguration': "Dual screen exception configuration",
    'FullStretch': "Full screen stretch",
    'GeometricScaling': "Geometric scaling",
    'FullDisplay': "Full size display",
    'reverse': "Interface reverse",
    'MandatoryAdaptation': "Mandatory adaptation",
    'Software': "Software restart in effect",
    'qbccj': "Please save the scene",
    'addImage': "Add images",
    'addMixture': "Adding mixed seeding",
    'addVideo': "Add video",
    'addAudio': "Add audio",
    'addDoc': "Add the document",
    'default_effect': "default effect",
    'right_to_left': "Right to left",
    'left_to_right': "Left to right",
    'top_to_bottom': "Top to bottom",
    'bottom_to_top': "Bottom to top",
    'accordion_squeeze': "accordion squeeze",
    'zoom_in_gradient': "zoom in gradient",
    'zoom_out_gradient': "zoom out gradient",
    'rotate_in': "3D rotate in",
    'rotate_out': "3D rotate out",
    'field_gradient': "Depth of field gradient",
    'Left_right_rotation': "Left right rotation",
    'up_and_down_rotation': "Up and down rotation",
    'counter_clockwise_rotation': "Counter clockwise rotation",
    'clockwise_rotation': "Clockwise rotation",
    'zoom_up_and_down': "Zoom up and down",
    'frame_effect': "3D frame effect",
    'scale_gradient': "Scale gradient",
    'zoom_in_on': "Zoom in on the cull animation",
    'transparent_gradient': "Transparent gradient",
    'gradient_scaling': "Gradient scaling",
    'upper_left_corner': "Upper left corner",
    'center_top': "Center top",
    'upper_right_corner': "Upper right corner",
    'center_left': "Center Left",
    'center': "Center",
    'center_right': "Center right",
    'lower_left_corner': "Lower left corner",
    'bottom_center': "Bottom center",
    'lower_right_corner': "Lower right corner",
    "copy": "copy",
    "ckhz": "Length and width",
  },
  task: {
    'createTask': 'create task',
    'bindingProgram': 'binding program',
    'releaseTask': 'release task',
    'addTask': 'add task',
    'tasktype': 'Type',
    'TaskName': 'Task name',
    'Playmode': 'Play mode',
    'ReplaceMode': 'Replace Mode',
    'AppendMode': 'Append Mode',
    'Spotpatterns': 'Spotpatterns',
    'TaskGroup': 'Grouping',
    'simulcastingmode': 'simulcasting Mode',
    'Broadcast': 'playback period',
    'Continue': 'Continue to play',
    'broadcasting': 'fixed time airplay',
    'newlyTask': 'The new task',
    'management': 'task management',
    'timehorizon': 'Time',
    'DownloadList': 'Download the list of',
    'information': 'Program information',
    'playback': 'Period',
    'Completed': 'Completed',
    'unfinished': 'unfinished',
    'ptrw': 'Common tasks',
    'sprw': 'Dual task',
    'pmlx': 'Screen category',
    'zmcb': 'Subtitles spots',
    'addprogram': 'add program',
    'jmfbl': 'resolution',
    'total': 'total',
    'cycle': 'period',
    'daterange': 'Date',
    'Editingtasks': 'Editing tasks',
    'ptlx': 'Common type',
    'splx': 'Double screen type',
    'hdlx': 'interactive type',
    'size': 'size',
    'interactive': 'interactive task',
    'equipment': 'View device',
    'deletask': 'Delete task',
    'taskimprom': 'Task export',
    'downloadsu': 'download successful',
    'downloading': 'downloading',
    "watching": "watching",
    "Waiting_download": "Waiting for download",
    "task_list": "task list"
  },
  btns: {
    'confirm': 'confirm',
    'newgroup': 'new group',
    'cancel': 'Cacel',
    'submit': 'Submit',
    'reset': 'reset',
    'rename': 'rename',
    'creation': 'Create',
    'export': 'Export',
    'importing': 'importing',
    'delete': 'Delete',
    'alldelete': 'all delete',
    'send': 'Send',
    'mainScreen': 'MainScreen',
    'viceScreen': 'SecondaryScreen',
    'preview': 'Preview',
    'add': 'Add',
    'save': 'Save',
    'removeAll': 'Clear All',
    'clearCompleted': 'ClearComplete',
    'remove': 'One key clearance',
    'refresh': 'flush',
    'search': 'search',
    'upgradeEquipment': 'Upgrade',
    'Editversion': 'EditVersion ',
    'inquire': 'query',
    'examine': 'See',
    'examineuser': 'SeeUser',
    'Retrieve': 'Search',
    'AKregister': 'registration',
    'edit': 'edit',
    'all': 'All',
    'clearaway': 'clearAway',
    'EmptyCanvas': 'Empty',
    'movegrouping': 'move Grouping',
    'uploadFiles': 'upload files',
    'newProgram': 'new program',
    'Akeytoempty': 'A key to empty',
    'addrole': 'add role',
    'enabled': 'enabled',
    'disable': 'disable',
    'clickupload': 'Click on the upload',
    'next': 'next',
    'back': 'back',
    'amend': 'amend',
    'addroles': 'Adding roles',
    'close': 'close',
    'updata': 'uploading',
    'open': 'open',
    'Traffic_statistics': 'Data Quota',
    'Broadcast_statistics': 'Playback Statistics',
  },
  management: {
    'essential': 'essential information ',
    'CustomerName': 'Name',
    'Authorization': 'Number',
    'capacity': 'capacity',
    'userState': 'State',
    'address': 'address',
    'Account': 'deadline',
    'servercapacity': 'Server capacity',
    'Addcustomer': 'Add the customer',
    'phone': 'Customer account',
    'Pass': 'password',
    'deleclient': 'Delete Customer',
    'ConfirmPass': 'confirm password',
    'name': 'Name',
    'adder': 'address',
    'effective': 'effective date',
    'serverPix': 'Server capacity can only be an integer multiple of 100',
    'Customer': 'Tel',
    'Customeraddress': 'Address',
    'distribution': 'channel of distribution',
    'xgkyrl': 'Modify available capacity',
    'sqsbts': 'Authorized device',
    'gross': 'gross',
    'used': 'Used',
    'Editrole': 'Edit Role',
    'rejection': 'Reason for rejection',
    'qdql': 'Light cleaning (delete program information)',
    'zdql': 'Moderate cleanup (delete all large media files in memory)',
    'gdql': 'Height cleaning (format SD card)',
    'exerrlog': 'Export error log',
    'exdelog': 'Export device log',
    "onlineNum": "onlineNum",
    "offLineNum": "offLineNum",
    'download_speed': 'rate-limiting',
    'serverrate': 'Download speed must not be greater than',
    'editcustomer': 'Edit the customer',
    'addcustomer': 'Add the customer',
    abcd: "Please enter username / mobile phone number",
    'cus_phone':'Customer cus_phone'
  },
  'usercenter': 'usercenter',
  'LogOff': 'LogOff',
  'account': 'account',
  'editpassword': 'CD KY',
  'edituser': 'edituser',
  'phone': 'phone',
  'uspix': 'Accounts can only be a combination of letters, Numbers, and alphanumeric',
  'oldPass': 'oldPass',
  'newPass': 'newPass',
  'ConfirmPass': 'ConfirmPass',
  'package': 'package',
  'WordDOC': 'WordDOC',
  'videoDetails': 'videoDetails',
  'Material': 'Material',
  'Program': 'Program',
  'Task': 'Task',
  'Settings': 'Deploy',
  'Terminal': 'Terminal',
  'Manage': 'Manage',
  'immediately': 'Immediately change',
  'lang': 'en',
  'zh': 'Chinese',
  'en': 'English',
  'version': 'Version',
  'customer': 'Modify customer',
  "download": "download",
  "download_again": "download again",
  "select_device": "select device",
  "prev": "prev",
  "next": "next",
  "day": "day",
  "tsfm": "Days at",
  "month": "month",

  communal: {
    placeholder: 'Please enter content',
    zwsj: 'No data',
    name: 'Name',
    describe: 'describe',

  },
  system: {
    'serverSettings': 'Server Settings',
    'thresholdSettings': 'max memory',
    'maxspeed': 'speed limit',
    'maxnumber': 'Download limit',
    'Memory': 'Cleanup level',
    'configuration': 'Check the configuration information to make sure the server runs smoothly',
    'ncql': 'Cleanup level',
    'yldh': 'Alarm call',
    'unit': 'unit',
    'Reserved': 'Reserved alarm phone',
    'maxmin': 'The maximum number of downloads is less than recommended',
    'custom': 'Please feel free to set',
    'management': 'role management',
    'phoneNumber': 'phone',
    'nickName': 'nickName',
    'creationTime': 'creation time',
    'operation': 'operation',
    'log': 'log management',
    'Module': 'Module Names',
    'action': 'action',
    'operationType': 'operation type',
    'newUsers': 'new users',
    'contact': 'contact way',
    'Review': 'audit',
    'confirmPassword': 'confirm password',
    'dualIp': 'dualIp',
    'userName': 'userName',
    'time': 'time',
    'qxzkssj': 'Please select the start time',
    'qxzjs': 'Please select the end time',
    'qxzmode': 'Please select the module name',
    'runningLog': 'running log',
    'operationLog': 'operation log',
    'logPS': 'Tip: export the server run error log',
    'sysHelp': 'system help',
    'Formatspecification': 'format specification',
    'fileFormat': 'file format',
    'imgFormat': 'picture format',
    'audioFormat': 'audio format',
    'videoFormat': 'video format',
    'softwareVersion': 'Version',
    'backup': 'backup',
    'instructions': 'instructions',
    'derivePS': 'Please click the export button for database backup before version update',
    'versionsPS': 'Re-enter the page of the publishing system after the updated version, click the import button to select the file exported by the export button above',
    'basicSetting': 'basic setting',
    'iscompress': 'iscompress',
    'isstatistics': 'isstatistics',
    'fileSize': 'upload size limit',
    'yes': 'yes',
    'no': 'no',
    'port': 'port',
    'wbgs': 'text formatting',
    'maximum': 'maximum',
    'Uploadconfiguration': 'Upload material configuration',
    'broadband': 'broadband',
    'addrole': 'The new role',
    'updated': 'updateDate',
    'details': 'Updated details',
    'customset': 'custom setting',
    'Wallpaper': 'Wallpaper',
    'landscape': 'landscape',
    'PorTrait': 'vertical',
    'xgsbyh': 'Remove device',
    'default': 'clear',
    'logout': 'exit password',
    'ps': 'Please enter user login account',
    'ad': 'Current task (yellow icon for replacement mode, blue icon for append mode, red icon for intermission mode, pink icon for synchronization mode)',
    'exsetsing': 'Export Settings',
    'upan': 'USB operate',
    'qjyl': 'Interval volume',
    "tzyl": "adjust volume",
    "assist": "Please find after-sales assistance for this operation"
  },
  common: {
    'state': 'state',
    'cmmfz': 'Rename group',
    'cmmsb': 'Rename device',
    'keyword': 'keyword'
  },
  msg: {
    qxzsb: 'Please select equipment',
    qxzsc: 'Please select material',
    phoneisenu: 'The phone number cannot be empty'
  },
  tip: {
    tip: 'Tip',
    warmprompt: 'Warm tip: this function can only be used in LAN, public network users do not use this function!',
    a: 'The switch - on interval must be greater than five minutes',
    b: 'The maximum number of downloads is recommended to be less than 70',
    b1: 'The maximum number of downloads is recommended to be less than 150',
    b2: 'The maximum number of downloads is recommended to be less than 200',
    c: 'Maximum download speed is recommended to be less than 200kb',
    c1: 'Maximum download speed is recommended to be less than 500kb',
    c2: 'Maximum download speed is recommended to be less than 1000kb',
    c3: 'Maximum download speed is recommended to be less than 2000kb',
    c4: 'Maximum download speed is recommended to be less than 5000kb',
    d: 'Document upload instructions',
    e: 'Please click the export button for database backup before version update',
    f: 'Re-enter the page of the publishing system after the updated version, click the import button to select the file exported by the export button above',
    g: 'Tip: export the server run error log',
    h: '(please note that the server is modified and positioned, and the device is out of sync)',
    j: 'The image will be compressed at < 1920 > pixels',
    k: 'When this function is turned off, the number and time of programs are not counted',
    cczjsc: 'This data will be permanently deleted. Do you want to continue?',
    qddc: 'Determine export',
    successfully: 'InforMsg',
    tjcg: 'successfully added',
    xgcg: 'modify successfully',
    fscg: 'send successfully',
    sccg: 'successfully delete',
    i: 'Will delete material that is not bound to the program',
    o: 'If the export',
    l: 'Program deletion (this program has been bound to the following tasks, confirm that programs and tasks will be permanently deleted!)',
    m: 'Make sure to clean the time switch machine',
    n: 'Canceled ',
    p: 'confirm delete?',
    q: 'Confirm modification?',
    z: "Please enter a number greater than 30",
    deletefailed: 'fail to delete ',
    editch: 'Edit success',
    editsb: 'Edit failure',
    xzwj: 'Please select upgrade file',
    ygwj: 'Only one file can be selected',
    imgv: 'Please enter the correct system version number of img file',
    iimgv: 'Please enter the system version number of the img file',
    zipv: 'Please enter the system version number of the zip file',
    sjsb: 'Identify upgrade equipment',
    znsck: 'Only empty folders can be deleted',
    sybz: 'Insufficient surplus space',
    aa: 'The task name must be between 2 and 50 words',
    bb: 'The task end date cannot be less than the start date',
    cc: 'The end time of a task cannot be less than the start time',
    dd: 'Task end time cannot equal start time',
    ee: 'The end time of the task cannot be less than the current time',
    ff: 'The task cycle cannot be empty',
    gg: 'Please select a program to bind to',
    hh: 'Please add a program to the screen',
    jj: 'Please add programs to screen two',
    beh: 'Version Numbers can only be pure Numbers',
    oned: 'Only one device can be checked',
    srpz: 'Please enter your phone number or account number',
    gecw: 'The user name is not properly formatted',
    wurew: 'No current task',
    qdqc: 'Ok clear, do you want to continue?',
    qddefbl: 'Whether to delete the resolution',
    qddesce: 'Delete scene or not?',
    ll: 'Duplicate file name, do you want to replace duplicate file?',
    qq: 'Determine to modify the current state?',
    ww: 'export etv-ip.txt into the root directory of U disk, plug in the device, and modify the server information',
    xx: 'ps:Clear all unused materials and tasks before the current date',
    sjbn: "Time cannot be less than 3S",
    ztxyzg: "Font needs sufficient spacing",
    nameim: "Name/company name cannot be blank",
    seletTime: "Please select a valid date",
    sqts: "The number of authorized machines must be greater than 0",
    cgsyts: "Exceed the remaining number",
    bnxy: "Cannot be less than the authorized number",
    bnxyrl: "Cannot be less than the used capacity",
    cgsy: "Excess capacity",
    frqrl: "The server capacity is too large",
    selekkh: "Please select a customer to delete",
    delekh: "Can only delete customers at the next level"
  },
  placeholder: {
    qsrfzmc: 'Please enter the group name',
    qsrszz: 'Please enter a numeric value',
    bzq: 'The phone number format is incorrect. Please enter an 11-digit phone number',
    qqrwz: 'Please enter url',
    qsrjmm: 'Please importation of old passwords',
    qsrsbid: 'Please enter device ID',
    qsrgjz: 'Please enter the keyword',
    qsrheight: 'Please enter the correct height',
    qsrwidth: 'Please enter the correct width',
    qsrbs: 'Please enter an integer multiple of 100',
    qsrz: 'Please enter a value between -1 and 999999',
    qsraddr: 'Please enter address',
    qsrbm: 'Please enter the package name',
    qsrbh: 'Please enter device number',
    qsrmm: 'Please enter an 8-digit password containing numbers, letters, and special characters',
    lcmmbyz: 'The two passwords entered do not match',
    a: 'The input capacity cannot be less than the used capacity',
    b: 'Input value too large',
    qxzcer: 'Please select the start date',
    qxzend: 'Please select the end date',
    qxztime: 'Please select the end time',
    qxzendtime: 'Please select the start time',
    qxzrwfz: 'Please select task groups',
    qxz: 'please choose',
    qxzjmfl: 'Please select program categories',
    qxzjm: 'Please select program',
    qxzrw: 'Please select task',
    qxzfbl: 'Please select resolution',
    qxzhdqy: 'Please select the activity area',
    qxzwzsj: 'Please select the full time period',
    qxzysc: 'Please select the file you want to delete',
    qxzfile: 'Please select file',
  },
  codekey: {
    err: 'Verification code error'
  },
  nav: {
    image: 'image',
    video: 'video',
    audio: 'audio',
    mixture: 'mixture',
    date: 'date',
    weeks: 'weeks',
    countDown: 'countDown',
    time: 'time',
    weather: 'weather',
    subtitle: 'subtitle',
    webPage: 'webPage',
    doc: 'doc',
    streaming: 'streaming',
    button: 'button',
    area: 'area',
    hdmin: "hdmin"
  },
  settimg: {
    'fontColor': 'fontColor',
    'bgColor': 'bgColor',
    'fontSize': 'fontSize',
    'direction': 'direction',
    'speed': 'rolling speed',
    'city': 'Select city',
    'effect': 'Switching effect',
    'uniformly': 'unified time',
    'time': 'time',
    'text': 'Subtitle content',
    'aligning': 'alignment',
    'nodes': 'time nodes',
    'unit': 'unit',
    'DXVA': 'DXVA',
    'isopen': 'isopen',
    'address': 'address',
    'btnFont': 'button text',
    'interact': 'interact',
    'still': 'still',
    'ms': 'low speed ',
    'zs': 'intermediate speed ',
    'ks': 'speediness',
    'bt': 'bottom up',
    'lr': 'left to right',
    'rl': 'right to left',
    'dwxs': 'unit display',
    "font": "font",
    "unity": "Unified volume setting",
    "no_trigger": "no trigger",
    "scene_jump": "scene jump",
    "website": "Third-party website",
    "preview": "Full screen preview ",
    "APK": "Third party APK ",
    "select": "Select scene",
    "addweb": "Add website",
    "addpacket": "Add the APK package",
    "volume": "Video volume",
    "Switching": "Switching time",
    "back": "Touch back",
    "noback": "Do not return",
    "return": "return",
    "stretch": "Pictures and videos get stretched",
  },
  edit_pass: {
    "account_center": "Account Security Center",
    "password_management": "Password Management",
    "enter_password": "Enter a new password",
    "ps1": "The current password is too simple, to protect your account security, please change the password as soon as possible",
    "please_new_password": "Please enter the new password you want to set",
    "submit": "Submit",
    "ps": "Please enter an 8-digit password with letters, numbers and English special symbols including '~@#$%^&+=!()*'",
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js